import { getRequest, postRequest } from '../../../services/requestService';
import * as types from './types';

/**
 * Fetch the user details and store them in Redux
 * This would work only if the user has JWT token stored in their cookie
 */
export const getSavedJobs = () => async dispatch => {
  const res = await postRequest('listing/list-saved-jobs');
  dispatch({ type: types.SET_SAVED_JOBS, payload: { savedJobs: res.data.jobs } })
}
export const fetchSavedJobs = ({ feed, callback }) => async dispatch => {
  dispatch({
    type: types.SET_SAVED_JOBS,
    payload: { isSavedJobsLoading: true }
  })
  const res = await postRequest(`listing/list-saved-jobs?feed=${feed}`);
  dispatch({
    type: types.SET_SAVED_JOBS,
    payload: { savedJobs: res.data.jobs, isSavedJobsLoading: false }
  })
}

export function setSavedJobs(savedJobs) {
  return {
    type: types.SET_SAVED_JOBS,
    payload: { savedJobs }
  }
}

export const refreshStats = () => async dispatch => {
  const res = await getRequest('listing/fetch-stats');
  dispatch({
    type: types.SET_STATS,
    payload: { ...res.data }
  })
}
export function setSearchParams(searchParams) {
  localStorage.setItem('searchParams', JSON.stringify(searchParams))
  return {
    type: types.SET_SEARCH_PARAMS,
    payload: { searchParams }
  }
}

export const updatedSavedJob = (newSavedJob) => async (dispatch, getState) => {
  let savedJobs = getState().JobsReducer.savedJobs;
  let didUpdate = false
  savedJobs = savedJobs.map(job => {
    if (job._id === newSavedJob._id) {
      didUpdate = true
      return newSavedJob;
    }

    return job;
  })
  if (!didUpdate) {
    savedJobs = [newSavedJob, ...savedJobs]
  }
  dispatch({ type: types.SET_SAVED_JOBS, payload: { savedJobs } })
}